import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Dialog, Field, Input } from '@dossierhq/design';
import { useCallback, useMemo, useState, } from 'react';
import { SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
const DialogStatus = {
    closed: 'closed',
    invalidFormat: 'invalidFormat',
    noChange: 'noChange',
    valid: 'valid',
};
const PATTERN_DEFAULT_HELP_TEXT = 'Enter a regular expression pattern.';
const PATTERN_STATUS_HELP_TEST = {
    [DialogStatus.invalidFormat]: 'The pattern must be a valid regular expression.',
};
export function EditPatternDialog({ selector, schemaEditorState, dispatchSchemaEditorState, onClose, }) {
    const [pattern, setPattern] = useState('');
    const [existingPattern, setExistingPattern] = useState('');
    const [lastSelector, setLastSelector] = useState(null);
    if (selector !== lastSelector) {
        const p = selector
            ? (schemaEditorState.patterns.find((it) => it.name === selector.name)?.pattern ?? '')
            : '';
        setPattern(p);
        setExistingPattern(p);
        setLastSelector(selector);
    }
    const status = useMemo(() => (selector ? validatePattern(pattern, existingPattern) : DialogStatus.closed), [selector, pattern, existingPattern]);
    const handlePatternChange = useCallback((event) => {
        setPattern(event.target.value);
    }, []);
    const handleClose = useCallback(async (_event, returnValue) => {
        if (!selector) {
            return;
        }
        if (returnValue === 'ok') {
            dispatchSchemaEditorState(new SchemaEditorActions.ChangePatternPattern(selector, pattern));
        }
        onClose();
    }, [dispatchSchemaEditorState, pattern, onClose, selector]);
    return (_jsx(Dialog, { show: !!selector, form: true, modal: true, onClose: handleClose, children: selector ? (_jsx(DialogContent, { selector,
            status,
            pattern,
            schemaEditorState,
            onPatternChange: handlePatternChange,
            onEnterKeyPress: () => status === DialogStatus.valid && handleClose(null, 'ok') })) : null }));
}
function validatePattern(pattern, existingPattern) {
    try {
        new RegExp(pattern);
    }
    catch {
        return DialogStatus.invalidFormat;
    }
    if (pattern === existingPattern) {
        return DialogStatus.noChange;
    }
    return DialogStatus.valid;
}
function DialogContent({ status, pattern, onPatternChange, onEnterKeyPress, }) {
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onEnterKeyPress();
        }
    }, [onEnterKeyPress]);
    const patternColor = status === DialogStatus.invalidFormat ? 'danger' : undefined;
    return (_jsxs(Card, { children: [_jsx(Card.Header, { children: _jsx(Card.HeaderTitle, { children: "Edit pattern" }) }), _jsx(Card.Content, { children: _jsxs(Field, { children: [_jsx(Field.Label, { children: "Pattern" }), _jsx(Field.Control, { children: _jsx(Input, { placeholder: "Enter pattern\u2026", color: patternColor, value: pattern, textStyle: "code1", onChange: onPatternChange, onKeyDown: handleKeyDown }) }), _jsx(Field.Help, { color: patternColor, children: PATTERN_STATUS_HELP_TEST[status] ?? PATTERN_DEFAULT_HELP_TEXT })] }) }), _jsxs(Card.Footer, { children: [_jsx(Card.FooterButton, { children: "Cancel" }), _jsx(Card.FooterButton, { value: "ok", disabled: status !== DialogStatus.valid, children: "Update" })] })] }));
}
//# sourceMappingURL=EditPatternDialog.js.map